var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22196 23.7797C8.68584 24.2442 9.23693 24.6125 9.84358 24.8634C10.4502 25.1143 11.1005 25.2429 11.757 25.2417C12.4136 25.2428 13.064 25.1143 13.6708 24.8634C14.2776 24.6125 14.8289 24.2442 15.293 23.7797L18.121 20.9507L16.707 19.5367L13.879 22.3657C13.3154 22.9267 12.5526 23.2416 11.7575 23.2416C10.9623 23.2416 10.1995 22.9267 9.63596 22.3657C9.07447 21.8024 8.75917 21.0395 8.75917 20.2442C8.75917 19.4488 9.07447 18.6859 9.63596 18.1227L12.465 15.2947L11.051 13.8807L8.22196 16.7087C7.28577 17.6471 6.76001 18.9186 6.76001 20.2442C6.76001 21.5698 7.28577 22.8412 8.22196 23.7797ZM23.778 15.2947C24.7137 14.356 25.2391 13.0846 25.2391 11.7592C25.2391 10.4338 24.7137 9.16239 23.778 8.22367C22.8395 7.28748 21.568 6.76172 20.2425 6.76172C18.9169 6.76172 17.6454 7.28748 16.707 8.22367L13.879 11.0527L15.293 12.4667L18.121 9.63767C18.6845 9.07666 19.4473 8.7617 20.2425 8.7617C21.0376 8.7617 21.8004 9.07666 22.364 9.63767C22.9255 10.2009 23.2408 10.9638 23.2408 11.7592C23.2408 12.5545 22.9255 13.3174 22.364 13.8807L19.535 16.7087L20.949 18.1227L23.778 15.2947Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.464 20.9518L11.049 19.5378L19.536 11.0518L20.95 12.4668L12.464 20.9518Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveLink);
export default __webpack_public_path__ + "static/media/save-link.b753e6f7c16216268beef250deee1177.svg";
export { ForwardRef as ReactComponent };